import { useState, useEffect } from "react";
import BASE_URL from "../../BASEURL";

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/review`);
      const data = await res.json();
      setReviews(data.reviews || []);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    } finally {
      setLoading(false);
    }
  };

  const deleteReview = async (id) => {
    if (window.confirm("Delete this review?")) {
      try {
        await fetch(`${BASE_URL}/api/review/${id}`, { method: "DELETE" });
        fetchReviews();
      } catch (error) {
        console.error("Error deleting review:", error);
      }
    }
  };

  if (loading) return <div>Loading reviews...</div>;

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Reviews</h2>
      <div className="bg-white border rounded overflow-x-auto">
        <table className="w-full text-sm text-left border-collapse">
          <thead className="bg-gray-100 border-b">
            <tr>
              <th className="p-2 border-r">User</th>
              <th className="p-2 border-r">Product</th>
              <th className="p-2 border-r">Rating</th>
              <th className="p-2 border-r">Comment</th>
              <th className="p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map((r) => (
              <tr key={r._id} className="border-b hover:bg-gray-50">
                <td className="p-2 border-r">{r.user?.name || "Unknown"}</td>
                <td className="p-2 border-r">{r.product?.productName || "Unknown"}</td>
                <td className="p-2 border-r">{r.rating}/5</td>
                <td className="p-2 border-r">{r.comment}</td>
                <td className="p-2">
                  <button onClick={() => deleteReview(r._id)} className="text-red-600 hover:underline">
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {reviews.length === 0 && (
              <tr><td colSpan="5" className="p-4 text-center">No reviews found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
